// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Smoking from '../_raw/service/icon_smoking.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Smoking);
